import React, { useState } from 'react';
import * as styles from './partnerSection.module.scss';
import { usePageContext } from '../context/pageContext';
import { SanityPartnerSection } from 'graphql-types';
import { GatsbyImage } from 'gatsby-plugin-image';
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import { CommentsSlider } from '../commentsSlider/CommentsSlider';
import { SwiperSlide } from 'swiper/react';
import { CommentsPagination } from '../commentsSlider/CommentsPagination';
import { findTranslation } from '../../utils/findTranslation';

interface Props {
  section?: SanityPartnerSection;
}

export const PartnerSection: React.FC<Props> = ({ section }) => {
  const { lang, defaultLang } = usePageContext();
  const [swiper, setSwiper] = useState<Swiper>();

  return (
    <div className={styles.wrapper}>
      <h2>{findTranslation(section?._rawTitleSection, lang, defaultLang)}</h2>

      <CommentsSlider setSwiper={setSwiper}>
        {section?.imagesList?.map((image, index) => {
          return (
            <SwiperSlide key={`comment-${index}`}>
              <div className={styles.comment}>
                <div className={styles.image}>
                  <GatsbyImage
                    alt={image?.alt ?? ''}
                    image={image?.img?.asset?.gatsbyImageData}
                  />
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </CommentsSlider>

      <CommentsPagination
        swiper={swiper}
        color={section?.colorNav ?? ''}
      />
    </div>
  );
};
